/**
 * app.js
 *
 * In theory, this is the entry point for JavaScript on the Slideview page.
 * In reality, scripts are strewn about the page like autumn leaves on a
 * moist, forest floor.
 *
 * One day.
 */
(function(ss, imports) {
  var isClippable = ss.slideshow && ss.slideshow.is_clippable,
    Recommendations = imports('slideview.Recommendations'),
    ClippingModule = imports('ClippingModule'),
    recommendations = new Recommendations('#side-panel'),
    clippingModule,
    $clipButton = $('.clip-button-top .clip-button'),

    classes = {
      visible: 'visible'
    };

  function init() {
    if (isClippable) {
      clippingModule = new ClippingModule({
        clipCounts: ss.slideshow.clip_counts,
        totalSlides: ss.slideshow.total_slides
      });
    }
  }

  init();

}(window.slideshare_object, window.slideshare_object.utils.imports));
